//LogoutButton.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
import { clearAuth } from "../api/reportApi";

export default function LogoutButton() {
    const navigate = useNavigate();

    const logout = () => {
        clearAuth();

        navigate("/login", {
            replace: true
        });
    };

    return (
        <button
            type="button"
            onClick={logout}
            className="px-4 py-2 rounded-xl bg-neutral-800 text-white hover:bg-neutral-700"
        >
            Logout
        </button>
    );
}